import { Link } from 'react-router-dom'
import { ChevronLeft, ChevronRight, Users, ShieldCheck } from 'lucide-react'
import { useAdminHome } from '@/hooks/useAdmin'

/** Sprint "Corrección Final Product Experience V2" (10/09/2026, Sección 7 del encargo):
 * "Administración" -- SOLO visible/accesible para ADMIN (`MorePage.tsx` la oculta a
 * cualquier no-ADMIN; la barrera REAL es `require_admin_role` en cada endpoint que consume,
 * nunca solo ocultar el enlace). Hub minimalista -- hoy solo Usuarios; preparado para sumar
 * más herramientas administrativas reutilizando siempre backend real, nunca una segunda
 * arquitectura. */
export function AdminHubPage() {
  const { data } = useAdminHome(true)
  const counts = data?.users_by_status
  const total = counts ? Object.values(counts).reduce((a, b) => a + b, 0) : null

  return (
    <div className="p-4 space-y-4 md:max-w-2xl md:mx-auto">
      <Link to="/mas" className="flex items-center gap-1 text-xs font-bold text-text-dim w-fit">
        <ChevronLeft className="h-4 w-4" /> Más
      </Link>
      <div className="flex items-center gap-2">
        <ShieldCheck className="h-5 w-5 text-exact" />
        <h1 className="text-lg font-black text-text">Administración</h1>
      </div>
      <p className="text-xs text-text-dim">Herramientas administrativas -- solo visibles para tu cuenta ADMIN.</p>

      <Link to="/mas/admin/usuarios" className="card p-4 rounded-2xl flex items-center justify-between hover:border-exact/40 transition block">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-exact-soft/20 border border-exact/30 flex items-center justify-center shrink-0">
            <Users className="h-5 w-5 text-exact" />
          </div>
          <div>
            <p className="text-sm font-bold text-text">Usuarios</p>
            <p className="text-[11px] text-text-dim">{total != null ? `${total} usuarios registrados` : 'Gestionar cuentas, planes y estado'}</p>
          </div>
        </div>
        <ChevronRight className="h-4 w-4 text-text-dim shrink-0" />
      </Link>
    </div>
  )
}
